<template>
  <edit-new />
</template>

<script>
import EditNew from '../components/editNew.vue';

export default {
  components: { EditNew },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped></style>
